/**
 * Default visible data columns per Admin list screen (Actions always appended).
 * Table shows these 3 + Actions = 4 columns until the user customizes.
 */
export const TABLE_COLUMN_DEFAULTS = {
  deals: ["dealId", "entName", "orgName"],
  enquiry: ["busName", "dealCategoryName", "contactName"],
  business: ["busName", "dealCategoryName", "businessTypeName"],
  investor: ["investorName", "investorTypeName", "email"],
  enterprise: ["entName", "pocName", "email"],
  creditLimit: ["orgName", "entName", "requestedCredit"],
  creditLimitRequests: ["orgName", "enterpriseName", "requestedCredit"],
  settlements: ["utr", "orgName", "amount"],
  payments: ["createdAt", "utr", "amount"],
  wallets: ["orgName", "vaAccountId", "balance"],
  manageUsers: ["userName", "email", "roleName"],
  manageRoles: ["roleId", "roleName", "Privilege"],
  manageRm: ["userName", "rmCityName", "usersAssigned"],
  managePermissions: ["privilegeId", "privilegeName", "privilegeCode"],
  jvDeals: ["dealId", "orgName", "dealName", "dealValue"],
};

export const buildTableScreenKey = (screen, suffix = "") =>
  `admin.${screen}${suffix ? `.${suffix}` : ""}.v2`;
